// @ts-nocheck
import { createBrowserHistory, History } from '/data/data.akualku/.jenkins/workspace/test-ec-mobile-openpay/node_modules/@umijs/runtime';

let options = {
  "basename": "/open-pay/"
};
if ((<any>window).routerBase) {
  options.basename = (<any>window).routerBase;
}

// remove initial history because of ssr
let history: History = process.env.__IS_SERVER ? null : createBrowserHistory(options);
export const createHistory = (hotReload = false) => {
  if (!hotReload && process.env.NODE_ENV === 'development') {
    history = createBrowserHistory(options);
  }

  return history;
};

export { history };
